import { NgModule } from '@angular/core';
import { CurrentUserStateService } from './services/current-user-state.service';
import { UsersService } from './services/users.service';
import { FullUserNamePipe } from './pipes/fullUserName/full-user-name.pipe';
import { AccountsApi } from '../../api/accounts/accounts.api';
import { UsersApi } from '../../api/users/users.api';
import { DataConnectorsApi } from '../../api/externalData/data-connectors.api';
import { UserApplicationPreferencesApi } from '../../api/userApplicationPreferences/userApplicationPreferences.api';
import { EventsApi } from '../../api/events/events-api';
import { AIApi } from '../../api/ai/AI-api';
import { G2Api } from '../../api/g2/g2.api';
import { LoginApi } from '../../api/login/login.api';
import { SessionManagementService } from '../../Bootstrap/services/session-management.service';
import { MfaService } from '../../Bootstrap/services/mfa.service';
import { EmailAccountConnectorApiService } from '../../api/emailAccountConnector/email-account-connector.api.service';
import { DataConnectionService } from './services/data-connection.service';

const declarations: any[] = [
    FullUserNamePipe
];

const exports: any[] = [
    FullUserNamePipe
];

@NgModule({
    declarations,
    exports,
    providers: [
        EventsApi,
        AccountsApi,
        UsersApi,
        G2Api,
        AIApi,
        LoginApi,
        SessionManagementService,
        DataConnectorsApi,
        CurrentUserStateService,
        {
            provide: 'UserStateProvider',
            useExisting: CurrentUserStateService
        },
        UsersService,
        UserApplicationPreferencesApi,
        MfaService,
        EmailAccountConnectorApiService,
        DataConnectionService
    ]
})
export class UsersModule { }
